import * as React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useRouteMatch } from "react-router-dom";
import { IHomeHeaderProfileMenu } from "../../models/interfaces/home-header-profile-menu.interface";

type HomeHeaderProfileMenuProps = {
  menu: IHomeHeaderProfileMenu;
};

const HomeHeaderProfileMenu = (props: HomeHeaderProfileMenuProps) => {
  const { menu } = props;
  const { t } = useTranslation();
  const match = useRouteMatch();

  const IMG = (imgName: string) => {
    return require(`./../../../../../../assets/icons/profile-menu/${imgName}.svg`)
      ?.default;
  };

  return (
    <div className="">
      <NavLink to={match.url + menu.routeUrl} className="flex py-2 hover:bg-gray-100">
        <span className="mx-3">
          <img className="h-4" src={IMG(menu.icon)} alt="" />
        </span>
        <span className="mx-2 text-xs font-semibold">{t(menu.labelKey)}</span>
      </NavLink>
    </div>
  );
};

export default HomeHeaderProfileMenu;
